export const pricingMetricsCollapse = [
  {
    key:'1',
    header:'Demand in the Last 7 Days',
  },
  {
    key:'2',
    header:'Occupancy Information',
  },
  {
    key:'3',
    header:'Price per Square Foot',
  },
  {
    key:'4',
    header:'Rent Pricing Calculator',
  },
];
